import React, { useEffect, useMemo, useState } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Option, isIOS } from 'components/Option';
import {
  PUBLISH_SHIFT,
  PUBLISH_SHIFT_LABELS,
  PUBLISH_SHIFT_ORDER,
} from 'pages/ScheduleV6/constants/shifts';
import styles from './styles';

const ShiftSelectionModal = ({
  classes,
  isOpen,
  onClose,
  onConfirm,
  availableShifts,
  defaultShift = PUBLISH_SHIFT.FULL,
}) => {
  const [shift, setShift] = useState(defaultShift);

  // The modal stays mounted across opens, so local state must be reset each
  // time it reopens — otherwise a previously picked shift sticks.
  useEffect(() => {
    if (isOpen) setShift(defaultShift);
  }, [isOpen, defaultShift]);

  const options = useMemo(
    () => PUBLISH_SHIFT_ORDER.filter((option) => {
      if (option === PUBLISH_SHIFT.FULL) return true;
      return availableShifts?.has?.(option);
    }),
    [availableShifts]
  );

  const handleSubmit = () => {
    onConfirm(shift);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="shift-selection-title"
      PaperProps={{ classes: { root: classes.dialogRoot } }}
    >
      <div className={classes.header}>
        <Typography
          id="shift-selection-title"
          variant="h5"
          color="textPrimary"
        >
          Publish Schedule
        </Typography>
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          aria-label="Close"
          disableRipple
        >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.content}>
        Please, choose the shift to be published.
        <TextField
          select
          id="shiftSelection"
          name="shiftSelection"
          value={shift}
          onChange={(e) => setShift(e.target.value)}
          className={classes.selector}
          variant="outlined"
          SelectProps={{ native: isIOS }}
        >
          {options.map((option) => (
            <Option key={option} value={option}>
              {PUBLISH_SHIFT_LABELS[option]}
            </Option>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          className={classes.publishBtn}
          disableTouchRipple
        >
          Publish
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ShiftSelectionModal.propTypes = {
  classes: propTypes.object.isRequired,
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  onConfirm: propTypes.func.isRequired,
  availableShifts: propTypes.instanceOf(Set),
  defaultShift: propTypes.string,
};

export default withStyles(styles)(ShiftSelectionModal);
